/*global chrome*/
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import Footer from "./Footer";
import NocBanner from "components/PublicPagesReusable/NocBanner";
import Header from "./Header";
import ButtonComp from "components/PublicPagesReusable/ButtonComp";
import Frame1 from "../../assets/images/public-pages/Frame1.svg";
import Frame2 from "../../assets/images/public-pages/Frame2.svg"
import Frame3 from "../../assets/images/public-pages/Frame3.svg"
import Frame4 from "../../assets/images/public-pages/Frame4.svg"
import Frame5 from "../../assets/images/public-pages/Frame5.svg";
import Frame6 from "../../assets/images/public-pages/Frame6.svg";
import Frame7 from "../../assets/images/public-pages/Frame7.svg";
import Frame8 from "../../assets/images/public-pages/Frame8.svg";
import Frame9 from "../../assets/images/public-pages/Frame9.svg";
import Frame10 from "../../assets/images/public-pages/Frame10.svg";
import Frame11 from "../../assets/images/public-pages/Frame11.svg";
import Frame12 from "../../assets/images/public-pages/Frame12.svg";
import Frame13 from "../../assets/images/public-pages/Frame13.svg";
import Frame14 from "../../assets/images/public-pages/Frame14.svg";
import Frame15 from "../../assets/images/public-pages/Frame15.svg";
import Frame16 from "../../assets/images/public-pages/Frame16.svg";
import Frame17 from "../../assets/images/public-pages/Frame17.svg";
import Frame18 from "../../assets/images/public-pages/Frame18.svg";
import Frame19 from "../../assets/images/public-pages/Frame19.svg";
import Frame20 from "../../assets/images/public-pages/Frame11.svg";

import IEFrame1 from "../../assets/images/public-pages/iletsScore-frame1.png";
import IEFrame2 from "../../assets/images/public-pages/iletsScore-frame2.png";
import IEFrame3 from "../../assets/images/public-pages/iletsScore-frame3.png";
import IEFrame4 from "../../assets/images/public-pages/iletsScore-frame4.png";
import IEFrame5 from "../../assets/images/public-pages/iletsScore-frame5.png";
import IEFrame6 from "../../assets/images/public-pages/iletsScore-frame6.png";
import IEFrame7 from "../../assets/images/public-pages/iletsScore-frame7.png";
import IEFrame8 from "../../assets/images/public-pages/iletsScore-frame8.png";
import IEFrame9 from "../../assets/images/public-pages/iletsScore-frame9.png";
import IEFrame10 from "../../assets/images/public-pages/iletsScore-frame10.png";
import IEFrame11 from "../../assets/images/public-pages/iletsScore-frame11.png";
import IEFrame12 from "../../assets/images/public-pages/iletsScore-frame12.png";
import IEFrame13 from "../../assets/images/public-pages/iletsScore-frame13.png";
import IEFrame14 from "../../assets/images/public-pages/iletsScore-frame14.png";
import IEFrame15 from "../../assets/images/public-pages/iletsScore-frame15.png";
import IEFrame16 from "../../assets/images/public-pages/iletsScore-frame16.png";
import IEFrame17 from "../../assets/images/public-pages/iletsScore-frame17.png";
import IEFrame18 from "../../assets/images/public-pages/iletsScore-frame18.png";
import IEFrame19 from "../../assets/images/public-pages/iletsScore-frame19.png";
import IEFrame20 from "../../assets/images/public-pages/iletsScore-frame19.png";
import AppBannerCustom from "components/PublicPagesReusable/AppBannerCustom";

const FameWallPte = React.memo(() => {
  const heroWorkTitle = () => {
    return (
      <h1 className="FS48 fw-500 top-section-text text-center">
        From Preparation to Perfection
        <br />
        <span className="fw-600 text-success">– Meet Our Champions</span>
      </h1>
    );
  };

  const heroData = {
    badge: "Wall of Fame",
    title: heroWorkTitle,
    subtitle: "Real students, real success stories.<br/>See how they achieved their dream PTE & NAATI CCL scores.",
    btnText:"Start Your Preparation",
    btnLink:"/auth/register",
  };

  const pteTitleSection = () => {
    return (
      <h3 className="top-section-text FS40FW600 m-0">
        <span className="text-success FS40FW600">PTE</span>{" "}Scorecards
      </h3>
    )
  }

  const pteScoreImages = [ {src: Frame1, alt: 'pte-score-1'}, {src: Frame2, alt: 'pte-score-2'}, {src: Frame3, alt: 'pte-score-3'}, {src: Frame4, alt: 'pte-score-4'}, {src: Frame5, alt: 'pte-score-5'}, {src: Frame6, alt: 'pte-score-6'}, {src: Frame7, alt: 'pte-score-7'}, {src: Frame8, alt: 'pte-score-8'}, {src: Frame9, alt: 'pte-score-9'}, {src: Frame10, alt: 'pte-score-10'}, {src: Frame11, alt: 'pte-score-11'}, {src: Frame12, alt: 'pte-score-12'}, {src: Frame13, alt: 'pte-score-13'}, {src: Frame14, alt: 'pte-score-14'}, {src: Frame15, alt: 'pte-score-15'}, {src: Frame16, alt: 'pte-score-16'}, {src: Frame17, alt: 'pte-score-17'}, {src: Frame18, alt: 'pte-score-18'}, {src: Frame19, alt: 'pte-score-19'}, {src: Frame20, alt: 'pte-score-20'} ];

  const naatiTitleSection = () => {
    return (
      <h3 className="top-section-text FS40FW600 m-0">
        <span className="text-success FS40FW600">NAATI CCL</span>{" "}Scorecards
      </h3>
    )
  }

  const naatiScoreImages = [
    {
      src: "/images/web-new-images/emojis/Updated/NAATI-CCL-Scorecards/Scorecard-1.png",
      alt: "score-1",
    },
    {
      src: "/images/web-new-images/emojis/Updated/NAATI-CCL-Scorecards/Scorecard-2.png",
      alt: "score-2",
    },
    {
      src: "/images/web-new-images/emojis/Updated/NAATI-CCL-Scorecards/Scorecard-3.png",
      alt: "score-3",
    },
    {
      src: "/images/web-new-images/emojis/Updated/NAATI-CCL-Scorecards/Scorecard-4.png",
      alt: "score-4",
    },
    {
      src: "/images/web-new-images/emojis/Updated/NAATI-CCL-Scorecards/Scorecard-5.png",
      alt: "score-5",
    },
    {
      src: "/images/web-new-images/emojis/Updated/NAATI-CCL-Scorecards/Scorecard-6.png",
      alt: "score-6",
    },
   {
    src: "/images/web-new-images/emojis/Updated/NAATI-CCL-Scorecards/Scorecard-7.png",
    alt: "score-7",
  },
  {
    src: "/images/web-new-images/emojis/Updated/NAATI-CCL-Scorecards/Scorecard-8.png",
    alt: "score-8",
  },
  {
    src: "/images/web-new-images/emojis/Updated/NAATI-CCL-Scorecards/Scorecard-9.png",
    alt: "score-9",
  },
  {
    src: "/images/web-new-images/emojis/Updated/NAATI-CCL-Scorecards/Scorecard-10.png",
    alt: "score-10",
  },
  {
      src: "/images/web-new-images/emojis/Updated/NAATI-CCL-Scorecards/Scorecard-11.png",
      alt: "score-11",
    },
    {
      src: "/images/web-new-images/emojis/Updated/NAATI-CCL-Scorecards/Scorecard-12.png",
      alt: "score-12",
    },
    {
      src: "/images/web-new-images/emojis/Updated/NAATI-CCL-Scorecards/Scorecard-13.png",
      alt: "score-13",
    },
    {
      src: "/images/web-new-images/emojis/Updated/NAATI-CCL-Scorecards/Scorecard-14.png",
      alt: "score-14",
    },
    {
      src: "/images/web-new-images/emojis/Updated/NAATI-CCL-Scorecards/Scorecard-15.png",
      alt: "score-15",
    },
    {
      src: "/images/web-new-images/emojis/Updated/NAATI-CCL-Scorecards/Scorecard-16.png",
      alt: "score-16",
    },
   {
    src: "/images/web-new-images/emojis/Updated/NAATI-CCL-Scorecards/Scorecard-17.png",
    alt: "score-17",
  },
  {
    src: "/images/web-new-images/emojis/Updated/NAATI-CCL-Scorecards/Scorecard-18.png",
    alt: "score-18",
  },
  {
    src: "/images/web-new-images/emojis/Updated/NAATI-CCL-Scorecards/Scorecard-19.png",
    alt: "score-19",
  },
  {
    src: "/images/web-new-images/emojis/Updated/NAATI-CCL-Scorecards/Scorecard-20.png",
    alt: "score-20",
  },
  ];

  const ieltsTitleSection = () => {
    return (
      <h3 className="top-section-text FS40FW600 m-0">
        <span className="text-success FS40FW600">IELTS</span>{" "}Scorecards
      </h3>
    )
  }

  const ieltsScoreImages = [
      { src: IEFrame1, alt: "score-1" }, { src: IEFrame2, alt: "score-2" }, { src: IEFrame3, alt: "score-3" },
      { src: IEFrame4, alt: "score-4" }, { src: IEFrame5, alt: "score-5" }, { src: IEFrame6, alt: "score-6" },
      { src: IEFrame7, alt: "score-7" }, { src: IEFrame8, alt: "score-8" },{ src: IEFrame9, alt: "score-9" }, 
      { src: IEFrame10, alt: "score-10" }, { src: IEFrame11, alt: "score-11" }, { src: IEFrame12, alt: "score-12" }, 
      { src: IEFrame13, alt: "score-13" },{ src: IEFrame14, alt: "score-14" },{ src: IEFrame15, alt: "score-15" }, 
      { src: IEFrame16, alt: "score-16" }, { src: IEFrame17, alt: "score-17" }, { src: IEFrame18, alt: "score-18" }, 
      { src: IEFrame19, alt: "score-19" },{ src: IEFrame20, alt: "score-20" }
    ];
  return (
    <React.Fragment>
      <Helmet>
        <title>Language Academy</title>
        <meta name="twitter:title" content="Language Academy" />
        <meta property="og:title" content="Language Academy" />
      </Helmet>
      <Header />

      <section className="new-design">
        <NocBanner data={heroData} extraClass={"contact-hero-section career-page"} extraClass2={"align-items-start"}/>
        <ScoreCardGallery
          titleSection={pteTitleSection}
          images={pteScoreImages}
          btnText={"Start Your PTE Preparation"}
          btnLink={'/auth/login'}
        />
        <ScoreCardGallery
          titleSection={naatiTitleSection}
          images={naatiScoreImages}
          btnText={"Start Your NAATI CCL Preparation"}
          btnLink={`${import.meta.env.VITE_NAATI_URL}auth/register`}
        />
        <ScoreCardGallery
          titleSection={ieltsTitleSection}
          images={ieltsScoreImages}
          btnText={"Start Your IELTS Preparation"}
          btnLink={`${import.meta.env.VITE_NAATI_URL}auth/register`}
        />
        <AppBannerCustom
          appName="PTE"
          description="PTE PRACTICE"
          mobileImage="/images/web-new-images/HomePageImage/PTE-app-1.png"
          playStoreLink={`${import.meta.env.VITE_PTE_ANDROID_APP_URL}`}
          appStoreLink={`${import.meta.env.VITE_PTE_IOS_APP_URL}`}
        />
        <Footer />
      </section>
    </React.Fragment>
  );
});

const ScoreCardGallery = ({ titleSection, images = [], btnText,btnLink }) => {
  return (
    <section className="scorecard-section py-5">
      <div className="custom-container">

        {/* Heading */}
        <div className="align-items-center d-flex justify-content-between mb-5 w-100 flex-column flex-md-row">
          {titleSection && titleSection()}
          <ButtonComp link={btnLink} btnText={btnText} className={""}/>
        </div>

        {/* Images Grid */}
        <div className="row g-3">

          {images?.map((img, index) => (
            <div
              key={index}
              className="
                col-6 col-sm-6-custom col-md-4-5 col-lg-2-5
              "
            >
              <div className="score-card h-100">
                <img
                  src={img.src}
                  alt={img.alt || `scorecard-${index}`}
                  className="img-fluid rounded-3 w-100"
                  loading={index < 4 ? "eager" : "lazy"}
                  fetchPriority={index < 4 ? "high" : "low"}
                />
              </div>
            </div>
          ))}

        </div>
      </div>
    </section>
  );
};

export default FameWallPte;
